export const AISE_MARKETPLACE_REPO_URL =
  'https://github.com/cfacorp/aise-marketplace';

export const AISE_MARKETPLACE_LINK_TEXT = 'AISE Marketplace';

export const AISE_MARKETPLACE_TOOLTIP = 'Skills for your IDE';
